/**
 * Trámites DIGECAM — tarjetas en la sección Trámites.
 * URLs de formulario oficial cuando existen en el portal; si no, página general de trámites.
 */
const FORM = (slug: string) =>
  `https://www.digecam.mil.gt/tramites-formulario/${slug}`;

export const DIGECAM_TRAMITES_GENERAL =
  "https://www.digecam.mil.gt/simplificacion-tramites";

export type DigecamTramiteCard = {
  /** Valor enviado en el formulario (type_license) */
  id: string;
  title: string;
  /** Enlace al formulario en línea o página de referencia DIGECAM */
  digecamUrl: string;
};

export const DIGECAM_TRAMITE_CARDS: DigecamTramiteCard[] = [
  {
    id: "registro_tenencia_compraventa_individual",
    title:
      "REGISTRO DE TENENCIA DE ARMA DE FUEGO CON CONTRATO DE COMPRAVENTA PARA PERSONA INDIVIDUAL",
    digecamUrl: DIGECAM_TRAMITES_GENERAL,
  },
  {
    id: "evaluacion_primera_licencia_portacion",
    title:
      "EVALUACIÓN Y PRIMERA LICENCIA DE PORTACIÓN DE ARMA DE FUEGO",
    digecamUrl: FORM("TVE9PQ=="),
  },
  {
    id: "renovacion_licencia_portacion",
    title: "RENOVACIÓN DE LICENCIA PARA PORTACIÓN DE ARMA DE FUEGO",
    digecamUrl: FORM("TVRBPQ=="),
  },
  {
    id: "agregar_suprimir_arma_licencia",
    title:
      "AGREGAR Y/O SUPRIMIR ARMA A LA LICENCIA DE PORTACIÓN DE ARMA DE FUEGO",
    digecamUrl: DIGECAM_TRAMITES_GENERAL,
  },
  {
    id: "reposicion_licencia_robo_hurto_extravio",
    title:
      "REPOSICIÓN DE LICENCIA DE PORTACIÓN DE ARMA DE FUEGO POR ROBO, HURTO, EXTRAVÍO O DETERIORO",
    digecamUrl: DIGECAM_TRAMITES_GENERAL,
  },
  {
    id: "licencia_traslado_esporadico",
    title: "LICENCIA DE TRASLADO ESPORÁDICO",
    digecamUrl: FORM("Tnc9PQ=="),
  },
  {
    id: "reposicion_tarjeta_tenencia_individual",
    title:
      "REPOSICIÓN DE TARJETA DE TENENCIA PARA PERSONA INDIVIDUAL POR ROBO, HURTO, EXTRAVÍO, DETERIORO O ACTUALIZACIÓN DE DATOS",
    digecamUrl: DIGECAM_TRAMITES_GENERAL,
  },
];
